import classnames from 'classnames';

export const Theme = {
  Default: 'border-orange-600',
  Accented: 'border-blue-900',
} as const;

export type Theme = (typeof Theme)[keyof typeof Theme];

type Props = {
  theme?: Theme;
  caption: string;
  children?: React.ReactNode;
};

const Component: React.FC<Props> = ({
  caption,
  children,
  theme = Theme.Default,
}) => {
  return (
    <div className="mb-3 w-full border-b border-solid border-gray-300">
      <div className="flex w-full items-center justify-between">
        <h2
          className={classnames([
            'border-l-8 border-solid px-2 py-1 text-xl font-semibold text-gray-600',
            theme,
          ])}
        >
          {caption}
        </h2>
        {children && <div className="h-full">{children}</div>}
      </div>
    </div>
  );
};

export default Component;
